import { useStorage } from '@/hooks/use-storage/use-storage';
import { JWTLocalStorage } from './use-jwt.types';

// Renaming this key signs out every existing session. Import it, do not repeat it.
export const JWT_STORAGE_KEY = 'voicesphere:auth_t';

const validateBearerToken = (persistedToken: unknown): persistedToken is JWTLocalStorage => {
  return typeof persistedToken === 'object' && !!persistedToken && 'token' in persistedToken;
};
const JWT_FALLBACK_VALUE = { token: '' };

export const useJWT = () => {
  const {
    value: { token: bearerToken },
    read: readToken,
    save: saveToken,
    remove: removeToken,
  } = useStorage<JWTLocalStorage>({
    storageKey: JWT_STORAGE_KEY,
    fallbackValue: JWT_FALLBACK_VALUE,
    validate: validateBearerToken,
  });

  return {
    bearerToken,
    readToken,
    saveToken,
    removeToken,
  };
};
